<template>
    <v-app>
      <v-layout row justify-center>
        <v-flex class="pl-4 pr-4 mt-3 mb-4" xs12 sm11>
          <v-card>
            <!-- ============================ TABLA MAGISTRADOS ============================ -->
            <v-toolbar color="grey" dark>
              <v-toolbar-title>Magistrados</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-dialog v-model="dialog" max-width="500px" persistent>
                <template v-slot:activator="{ on }">
                  <v-toolbar-items>
                    <v-btn dark text v-on="on">
                      Nuevo
                    </v-btn>
                  </v-toolbar-items>
                </template>
                <!-- FORMULARIO PARA CREAR/EDITAR MAGISTRADOS -->
                <v-card>
                  <v-card-title>
                    <span class="headline">{{ formTitle }}</span>
                  </v-card-title>
                  <v-card-text>
                    <v-container grid-list-md>
                      <v-form @submit.prevent="save" ref="form" v-model="valid" lazy-validation>
                        <v-layout wrap>
                          <v-flex xs12>
                            <v-text-field 
                                v-model.trim="editedItem.nombre" 
                                label="Nombre" 
                                :rules="notBlankRules"
                            >
                             </v-text-field>
                          </v-flex>
                          <v-flex>
                            <v-text-field 
                                v-model.trim="editedItem.primer_apellido" 
                                label="Primer Apellido" 
                                :rules="notBlankRules"
                            >
                            </v-text-field>
                          </v-flex>
                          <v-flex>
                            <v-text-field 
                                v-model.trim="editedItem.segundo_apellido" 
                                label="Segundo Apellido" 
                                :rules="notBlankRules"
                            >
                            </v-text-field>
                          </v-flex>
                          <v-flex xs12>
                            <v-select
                                :items="listSalas"
                                v-model="editedItem.sala_id"
                                label="Sala"
                                item-value="id"
                                item-text="nombre"
                                :rules="notBlankRules"
                            ></v-select>
                          </v-flex>
                          <v-flex xs12>
                            <v-checkbox
                              v-if="editedIndex > -1"
                              v-model="activo"
                              label="Activo"
                              :value="activo"
                            ></v-checkbox>
                          </v-flex>
                          <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="red darken-1" dark @click.native="close">Cancelar</v-btn>
                            <v-btn v-if="editedIndex > -1" color="yellow darken-2" dark @click.native="editMagistrado(editedItem)" :disabled="loading" :loading="loading">Actualizar</v-btn>
                            <v-btn v-else color="yellow darken-2" dark @click.native="addMagistrado(editedItem)" :disabled="loading" :loading="loading">Guardar</v-btn>
                          </v-card-actions>
                        </v-layout>
                      </v-form>
                    </v-container>
                  </v-card-text>
                </v-card>
              </v-dialog><!-- end dialog edit o save-->
            </v-toolbar>
            <!-- CONTENIDO DE LA TABLA MAGISTRADOS -->
            <v-card-title>
              <v-select
                label="Filtrar por Sala"
                item-text="nombre"
                item-value="id"
                :items="listSalas"
                v-model="search"
                clearable
                @change="getMagistrados()"
              ></v-select>
            </v-card-title>
            <v-data-table
              light
              actions
              :headers="headers"
              :items="listMagistrados"
              :page.sync="page"
              :items-per-page="itemsPerPage"
              @page-count="pageCount = $event"
              :loading="loading"
              loading-text="Cargando... Por favor espere"
              no-results-text="La busqueda no arrojo resultados."
              hide-default-footer
              class="elevation-1"
            >
              <template v-slot:[`item.activo`]="{ item }">
                <v-icon v-if="!item.deleted_at"
                    class="mr-2"
                    color="green"
                >mdi-check-bold</v-icon>
                <v-icon v-else
                    class="mr-2"
                    color="grey"
                >mdi-minus</v-icon>
              </template>
              <template v-slot:[`item.action`]="{ item }">
                <v-icon color="orange"  class="mr-2" @click="editItem(item)">mdi-pencil</v-icon>
                <v-icon v-if="!item.deleted_at" color="red"  @click="deleteMagistrado(item)">mdi-close</v-icon>
              </template>
            </v-data-table>
            <v-pagination v-if="pageCount > 1"
              v-model="page"
              :length="pageCount"
              color="#AF8936"
            ></v-pagination>
          </v-card>
        </v-flex>
      </v-layout>
  
    </v-app>
  </template>
  
  <script>
  import { mapGetters } from "vuex";
  const Swal = require('sweetalert2');
  export default {
  
    data() {
      return {
        search:'',
        loading: false,
        page: 1,
        pageCount: 0,
        itemsPerPage: 20,
        valid: true,
        dialog: false,
        show: false,
        headers: [
          { text: 'Nombre', value: 'ncompleto', sortable: true },
          { text: 'Sala', value: 'salas.nombre', sortable: true },
          { text: 'Activo', value: 'activo', sortable: true },
          { text: 'Acciones', value: 'action', width: '15%' }
        ],
        distritosList:[],
        editedIndex: -1,
        activo: true,
        editedItem: {
          nombre:'',
          primer_apellido: '',
          segundo_apellido: '',
          sala_id: '',
        },
        defaultItem: {
            nombre:'',
            primer_apellido: '',
            segundo_apellido: '',
            sala_id: '',
        },
        message: '',
        notBlankRules: [v => !!v || 'Este campo es requerido'],
      }
    },
    computed: {
      formTitle () {
        return this.editedIndex === -1 ? 'Nuevo Magistrado' : 'Editar Magistrado'
      },
      ...mapGetters([
        "listMagistrados",
        "listSalas"
      ]),
    },
    mounted() {
      this.getMagistrados();
      this.getSalas();
    },
    methods: {
        getMagistrados() {
          if (this.search) {
            this.loading = true;
            const sala_id = this.search;
            this.$store.dispatch("GET_MAGISTRADOS", { url: `/magistrados?sala_id=${sala_id}`})
            .then((response) => {
              this.loading = false;
            })
            .catch(error => {
                console.log(error);
            });
          } else {
            this.loading = true;
            this.$store.dispatch("GET_MAGISTRADOS", { url: "/magistrados"})
            .then((response) => {
              this.loading = false;
            })
            .catch(error => {
                console.log(error);
            });
          }
        },
        editItem (item) {
            this.editedIndex = this.listMagistrados.indexOf(item)
            this.editedItem = Object.assign({}, item)
            this.dialog = true
            if (this.editedItem.deleted_at) {
            this.activo = false
            }else {
            this.activo = true
            }
        },
        addMagistrado(){
          if (this.$refs.form.validate()) {
            var data = this.editedItem;
            this.$store.dispatch("SAVE_ROLES",  { url: "/magistrado", data: data } ).then((result) => {
              this.close ();
              Swal.fire({
                icon: 'success',
                title: 'Magistrado guardado correctamente',
                showConfirmButton: false,
                timer: 1500
              })
              window.location = "/magistrados"
            })
            .catch(error => {
                console.log(error);
            });
          }
        },
        editMagistrado(item){
          item.activo = this.activo
          if (this.$refs.form.validate()) {
            this.$store.dispatch("EDIT_MAGISTRADO",  { url: `/magistrado/${item.id}`, data: item } ).then(response => {
              Swal.fire({
                icon: 'success',
                title: 'Magistrado actualizado correctamente',
                showConfirmButton: false,
                timer: 1500
              })
              window.location = "/magistrados"
            })
            .catch(error => {
                console.log(error);
            });
            this.close()
          }
        },
        deleteMagistrado(item){
          this.$swal({
            icon: 'warning',
            title: '¡Atención!',
            html: `<h3>¿Deseas eliminar a <br>${item.ncompleto}?</h3>`,
            showCancelButton: true,
            showClass: true,
            confirmButtonText: "Aceptar"
          }).then((result) => {
              if (result.value) {
                this.$store.dispatch("DELETE_MAGISTRADO",  { url: `/magistrado/${item.id}`} ).then(response => {
                  Swal.fire({
                      icon: 'success',
                      title: 'Magistrado eliminado correctamente.',
                      showConfirmButton: false,
                      timer: 1500
                  })
                  this.getMagistrados();
                })
                .catch(error => {
                  console.log(error);
                });
              }
          })
        },
        getSalas() {
            this.$store.dispatch("GET_SALAS",  { url: "/salas" }).then((response) => {
            })
            .catch(err => {
                console.log(err);
            });
        },
        close () {
            this.dialog = false
            setTimeout(() => {
            this.$refs.form.reset()
            this.editedItem = Object.assign({}, this.defaultItem)
            this.editedIndex = -1
            this.dialog = false
            }, 300)
        },
    }
  }
  </script>
  